import { TFunction } from 'i18next';
import { IntegrationConfigBase } from 'models/integrations/integrationConfigBase';
import { IIntegrationEvidence } from 'models/integrations/integrationEvidence';
import { toLocaleDateTime } from 'utils/datetime';

//
// Config class: the integration has no parameters; the config root exists for the envelope only
//
export class IntegrationConfig_MS_AppRegistrationRestricted extends IntegrationConfigBase {}

//
// Evidence class: the one setting read, the outcome and when it was read
//
export class MS_AppRegistrationRestrictedEvidence implements IIntegrationEvidence {
  isCapped: boolean = false;

  evaluatedAtUtc: Date = new Date();

  //undefined when Graph did not answer the property: shown as unknown, never as a pass
  allowedToCreateApps: boolean | undefined = undefined;

  pass: boolean = false;

  getFoundText(t: TFunction<string[]>): string {
    if (this.allowedToCreateApps === undefined) return t('integrations:MS_AppRegistrationRestricted.Result.Unknown');

    return this.allowedToCreateApps ? t('translation:General.Words.Yes') : t('translation:General.Words.No');
  }

  toMarkdownReport(t: TFunction<['translation', 'integrations']>): string {
    const sb: string[] = [];

    sb.push(
      `## ${t('integrations:MS_AppRegistrationRestricted.Report.SummaryHeading', {
        date: toLocaleDateTime(this.evaluatedAtUtc),
      })}`,
    );
    sb.push(
      `- ${t('integrations:MS_AppRegistrationRestricted.Report.SettingLine', {
        found: this.getFoundText(t),
        expected: t('translation:General.Words.No'),
      })}`,
    );
    sb.push(
      `- ${t('integrations:MS_AppRegistrationRestricted.Report.OutcomeLine', {
        outcome: this.pass
          ? t('integrations:MS_AppRegistrationRestricted.Result.Pass')
          : t('integrations:MS_AppRegistrationRestricted.Result.Fail'),
      })}`,
    );

    return sb.join('\n');
  }
}

export const parse_Evidence_MS_AppRegistrationRestricted = (
  raw: string | undefined,
): MS_AppRegistrationRestrictedEvidence | undefined => {
  if (!raw) return undefined;

  const rawEvidence = JSON.parse(raw);
  if (!rawEvidence) return undefined;

  const evidence = new MS_AppRegistrationRestrictedEvidence();
  evidence.isCapped = rawEvidence.isCapped ?? false;
  evidence.evaluatedAtUtc = rawEvidence.evaluatedAtUtc ? new Date(rawEvidence.evaluatedAtUtc) : new Date();
  evidence.allowedToCreateApps =
    typeof rawEvidence.allowedToCreateApps === 'boolean' ? rawEvidence.allowedToCreateApps : undefined;
  evidence.pass = rawEvidence.pass ?? false;

  return evidence;
};
